// src/hooks/useArtworkThirdPartyAccess.js
import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabaseClient";

export function useArtworkThirdPartyAccess({ artworkId, enabled = true }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAccess = useCallback(async () => {
    if (!artworkId || !enabled) {
      console.log("[useArtworkThirdPartyAccess] Skipped - no artworkId or not enabled");
      setItems([]);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      console.log("[useArtworkThirdPartyAccess] 🔍 Fetching access for:", artworkId);

      // Appel RPC
      const { data: access, error: accessErr } = await supabase
        .rpc('get_artwork_all_access_with_profiles', { p_artwork_id: artworkId });

      console.log("[useArtworkThirdPartyAccess] 📊 Raw response:", { access, accessErr });

      if (accessErr) {
        console.error("[useArtworkThirdPartyAccess] ❌ Error:", accessErr);
        console.error("[useArtworkThirdPartyAccess] ❌ Error code:", accessErr.code);
        console.error("[useArtworkThirdPartyAccess] ❌ Error message:", accessErr.message);
        throw accessErr;
      }

      const normalized = normalizeShares(access || []);
      console.log("[useArtworkThirdPartyAccess] ✅ Normalized:", normalized);

      setItems(normalized);
    } catch (err) {
      console.error("[useArtworkThirdPartyAccess] ❌ Catch error:", err);
      setError(err);
      setItems([]);
    } finally {
      setLoading(false);
    }
}, [artworkId, enabled]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchAccess();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artworkId, enabled]);

  return {
    items,
    loading,
    error,
    refetch: fetchAccess,
  };
}

function normalizeShares(shares) {
  if (!Array.isArray(shares)) {
    console.warn("[normalizeShares] Input is not an array:", shares);
    return [];
  }

  return shares.map((share) => {
    const profile = {
      email: share.profile_email,
      full_name: share.profile_full_name,
      first_name: share.profile_first_name,
      last_name: share.profile_last_name,
      role: share.profile_role,
    };
    
    let displayName = "Utilisateur";
    
    if (profile.full_name) {
      displayName = profile.full_name;
    } else if (profile.first_name || profile.last_name) {
      displayName = [profile.first_name, profile.last_name]
        .filter(Boolean)
        .join(" ");
    } else if (profile.email) {
      displayName = profile.email.split("@")[0];
    }

    return {
      id: share.id,
      artwork_id: share.artwork_id,
      shared_with_id: share.shared_with_id,
      shared_with_name: displayName,
      shared_with_email: profile.email || null,
      shared_with_role: profile.role || "viewer",
      shared_at: share.shared_at,
      can_edit: share.can_edit || false,
      shared_by_id: share.shared_by_id,
      // Nouveaux champs
      access_type: share.access_type,
      collection_id: share.collection_id,
    };
  });
}